export default __webpack_public_path__ + "static/media/person.037e8067.svg";